/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_NavInputs */

const en_dr_nav = /** @type {(inputs: Dr_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Design Room`)
};

const id_dr_nav = /** @type {(inputs: Dr_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Design Room`)
};

/**
* | output |
* | --- |
* | "Design Room" |
*
* @param {Dr_NavInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_nav = /** @type {((inputs?: Dr_NavInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_NavInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_nav(inputs)
	return en_dr_nav(inputs)
});